import React from 'react';
import { useScopedI18n } from '@locales/client';

import { Box } from '@/shared/ui/box';
import TrashIcon from '@/shared/assets/trash-icon.svg';
import { Condition } from '@/shared/ui/condition';
import { BodyTextBoldSecondary } from '@/shared/ui/typography';
import { BodyTextMediumB } from '@/shared/ui/typography2';
import {
  useFormSave,
  useAddressSelection,
} from '@/features/wallet-managment/model/hooks';
import { getCardFieldFiat } from '@/features/wallet-managment/model/utils';
import { AddressBlock } from '../withdraw-form/styles';
import { Operations } from './styles';

export interface AdressesDetailProps {
  keyAddres: string;
  onEdit: (address: any) => void;
  inputValue: Record<string, string>;
}

export const AdressesDetailFiat = ({
  keyAddres,
  onEdit,
  inputValue,
}: AdressesDetailProps) => {
  const t = useScopedI18n('wallet');
  const { savePay, handleDeleteSavePay, mutateSavePay } =
    useFormSave(keyAddres);

  const {
    selectedAddress,
    blinkingAddress,
    setSelectedAddress,
    setBlinkingAddress,
  } = useAddressSelection({
    inputValue: inputValue?.[keyAddres] || '',
    savedAddresses: savePay || [],
    addressKey: keyAddres,
    onEdit,
  });

  const handleDeleteAddress = async (e: React.MouseEvent, key: any) => {
    e.stopPropagation();
    const keyIndef = key?.card || key?.iban || key?.binpay;
    await handleDeleteSavePay(keyIndef);
    await mutateSavePay();

    if (selectedAddress === key[keyAddres]) {
      setSelectedAddress(null);
      onEdit(null);
    }
  };

  if (!savePay?.length) return null;

  return (
    <Condition match={true}>
      <BodyTextBoldSecondary color="#AFAFAF">
        {t('withdraw.save_address.title')}
      </BodyTextBoldSecondary>

      <Box
        $display="flex"
        $gap={16}
        $flexDirection="column"
        $marginTop="5px"
        $maxHeight="180px"
        $overflowY="scroll"
      >
        {savePay.map((el, i) => {
          const addressValue = el[keyAddres];
          const isSelected = selectedAddress === addressValue;
          const isBlinking = blinkingAddress === addressValue;

          return (
            <AddressBlock
              key={`${addressValue}_${i}`}
              $border={isSelected}
              $blinking={isBlinking}
              onClick={() => {
                setSelectedAddress(addressValue);
                setBlinkingAddress(null);
                onEdit(el);
              }}
            >
              <Box $display="flex" $flexDirection="column" $gap={16}>
                <Box
                  $display="flex"
                  $alignItems="center"
                  $justifyContent="space-between"
                >
                  <Box>
                    <BodyTextMediumB color={i === 0 ? '#FF7001' : '#FFFF'}>
                      {getCardFieldFiat(el, keyAddres)}
                    </BodyTextMediumB>
                  </Box>
                  <Operations $display="flex" $gap={16} $alignItems="center">
                    <TrashIcon onClick={(e) => handleDeleteAddress(e, el)} />
                  </Operations>
                </Box>
              </Box>
            </AddressBlock>
          );
        })}
      </Box>
    </Condition>
  );
};
